import { makeStyles } from '@material-ui/core'

export const useTableStyles = makeStyles(theme => ({
  filterHeader: {
    backgroundColor: '#FFF0B2 !important',
  },
  sortAsc: {
    boxShadow: 'inset 0 3px 0 0 rgba(0,0,0,.6)',
  },
  sortDesc: {
    boxShadow: 'inset 0 -3px 0 0 rgba(0,0,0,.6)',
  },
  selectedRow: {
    background: '#5C8DE8',
  },
  selectedCell: {
    color: 'white',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    msTextOverflow: 'ellipsis',
    OTextOverflow: 'ellipsis',
    textOverflow: 'ellipsis',
    border: '1px solid rgba(0,0,0,0.05)',
    borderLeft: '1px solid rgba(0,0,0,0.02)',
    borderRight: '1px solid rgba(0,0,0,0.02)',
    '&:first-child': {
      'border-left': '0',
    },
    '&:last-child': {
      'border-right': '0',
    },
  },
  header: {
    cursor: 'pointer',
  },
  cell: {
    padding: '0 8px',
    backgroundColor: '#FFF',
    fontWeight: 400,
    fontFamily: 'Nunito, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    msTextOverflow: 'ellipsis',
    OTextOverflow: 'ellipsis',
    textOverflow: 'ellipsis',
    border: '1px solid rgba(0,0,0,0.05)',
    borderLeft: '0',
    borderRight: '0',
    color: '#000',
    transition: 'background-color 2s ease-out',
    // Needed to make cell content being vertically aligned to the top, when expandable cell is expanded
    verticalAlign: 'top',
    '&>div': {
      minHeight: '42px',
      display: 'flex',
      alignItems: 'center',
    },
    // End of needed to make cell content being vertically aligned to the top, when expandable cell is expanded
    '&:first-child': {
      'border-left': '0',
    },
    '&:last-child': {
      'border-right': '0',
    },
    '&$highlight': {
      backgroundColor: '#C0FFD8',
    },
  },
  highlight: {},
  headerCell: {
    backgroundColor: '#FFF',
    fontWeight: 700,
    fontFamily: 'Nunito, sans-serif',
    fontSize: '11px',
    lineHeight: '16px',
    letterSpacing: '0.5px',
  },
  selectHeaderCell: {
    // @ts-ignore
    backgroundColor: theme.palette.background.green,
  },
  warningRow: {
    // @ts-ignore
    backgroundColor: theme.palette.background.warning,
    '& td': {
      fontWeight: 'bold',
    },
  },
  resizer: {
    display: 'inline-block',
    width: '10px',
    height: '100%',
    position: 'absolute',
    right: 0,
    top: 0,
    transform: 'translateX(50%)',
    zIndex: 1,
    touchAction: 'none',
  },
  wrapHeader: {
    whiteSpace: 'normal',
  },
  pagination: {
    fontWeight: 400,
    fontFamily: 'Nunito, sans-serif',
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0.4px',
  },
  spacer: {
    display: 'none',
  },
  table: { width: 'auto' },
  compactView: {
    width: 'auto',
    overflow: 'hidden',
  },
}))
